interface BrowserInfo {
    name: string;
    version: string;
}

interface DeviceInfo {
    type: 'desktop' | 'mobile' | 'tablet';
    os: string;
    osVersion: string;
}

export function getBrowserInfo(): BrowserInfo {
    if (typeof navigator === 'undefined') {
        return { name: 'Unknown', version: 'Unknown' };
    }

    const ua = navigator.userAgent;

    // Chrome
    if (/Chrome\/(\d+)/.test(ua) && !/Edg\//.test(ua)) {
        const match = ua.match(/Chrome\/(\d+)/);
        return { name: 'Chrome', version: match ? match[1] : 'Unknown' };
    }

    // Firefox
    if (/Firefox\/(\d+)/.test(ua)) {
        const match = ua.match(/Firefox\/(\d+)/);
        return { name: 'Firefox', version: match ? match[1] : 'Unknown' };
    }

    // Safari
    if (/Safari\/(\d+)/.test(ua) && !/Chrome/.test(ua)) {
        const match = ua.match(/Version\/(\d+)/);
        return { name: 'Safari', version: match ? match[1] : 'Unknown' };
    }

    // Edge
    if (/Edg\/(\d+)/.test(ua)) {
        const match = ua.match(/Edg\/(\d+)/);
        return { name: 'Edge', version: match ? match[1] : 'Unknown' };
    }

    // IE
    if (/Trident/.test(ua)) {
        const match = ua.match(/rv:(\d+)/);
        return { name: 'Internet Explorer', version: match ? match[1] : 'Unknown' };
    }

    return { name: 'Unknown', version: 'Unknown' };
}

export function getDeviceInfo(): DeviceInfo {
    if (typeof navigator === 'undefined') {
        return { type: 'desktop', os: 'Unknown', osVersion: 'Unknown' };
    }

    const ua = navigator.userAgent;

    // Detect OS
    let os = 'Unknown';
    let osVersion = 'Unknown';

    if (/Windows NT (\d+\.\d+)/.test(ua)) {
        os = 'Windows';
        const match = ua.match(/Windows NT (\d+\.\d+)/);
        if (match) {
            const ntVersion = match[1];
            const versionMap: Record<string, string> = {
                '10.0': '10',
                '6.3': '8.1',
                '6.2': '8',
                '6.1': '7',
            };
            osVersion = versionMap[ntVersion] || ntVersion;
        }
    } else if (/Mac OS X (\d+[._]\d+)/.test(ua)) {
        os = 'Mac OS X';
        const match = ua.match(/Mac OS X (\d+[._]\d+)/);
        osVersion = match ? match[1].replace('_', '.') : 'Unknown';
    } else if (/Android (\d+)/.test(ua)) {
        os = 'Android';
        const match = ua.match(/Android (\d+)/);
        osVersion = match ? match[1] : 'Unknown';
    } else if (/iPhone OS (\d+)/.test(ua) || /iPad.*OS (\d+)/.test(ua)) {
        os = 'iOS';
        const match = ua.match(/OS (\d+)/);
        osVersion = match ? match[1] : 'Unknown';
    } else if (/Linux/.test(ua)) {
        os = 'Linux';
    }

    // Detect device type
    let type: DeviceInfo['type'] = 'desktop';

    if (/Mobi|Android.*Mobile|iPhone|iPod/.test(ua)) {
        type = 'mobile';
    } else if (/iPad|Android(?!.*Mobile)|Tablet/.test(ua)) {
        type = 'tablet';
    }

    return { type, os, osVersion };
}
